module.exports = __webpack_public_path__ + "static/media/14.577573e2.png";